// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Card__card___UYHCA{width:400px;border:1px solid #eae9e3;border-radius:8px;word-wrap:anywhere;cursor:pointer;transition:all .3s ease}@media (max-width:1279px){.Card__card___UYHCA{width:350px}}@media (max-width:719px){.Card__card___UYHCA{width:320px}}.Card__card___UYHCA:hover{box-shadow:2px 2px 8px #d5d4cf;transform:translate(-2px,-2px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"card": "Card__card___UYHCA"
};
module.exports = ___CSS_LOADER_EXPORT___;
